import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-role',
  templateUrl: './delete-role.component.html',
  styleUrls: ['./delete-role.component.css']
})
export class DeleteRoleComponent implements OnInit {

  roles: any;
  deleteId: any = "";
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllRoles()
  }
  
  getAllRoles(){
    this.generic_service.getAllRoles().subscribe(
      (response:any)=>{
        console.log(response)
        this.roles = response.response
      }
    )
  }
  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event;
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
  }

  deleteRole(){
    this.generic_service.deleteRole(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllRoles();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}
